import React, {useEffect, useImperativeHandle, useMemo} from 'react';
import {isMobile} from 'react-device-detect';
import {useHistory} from 'react-router-dom';
import {useFormik} from 'formik';
import {api} from '../../../../services';
import * as Yup from 'yup';

import {isEmptyObject} from '../../../../helpers';
import {strings} from '../../../../assets';
import {Mask} from '@tboerc/maskfy';

const CALLER = 'RESUMO';

const INITIAL_VALUES = {
  termos: true,
  coords: '',
};

const somarTotal = (coberturas, id_modalidade) => {
  let total = 0;

  coberturas.forEach((cob) => {
    total += parseFloat(cob.valor);
  });

  if (id_modalidade === 6 && total < 536.9) {
    total = 536.9;
  } else if (id_modalidade === 7 && total < 268.45) {
    total = 268.45;
  } else if ((id_modalidade === 8 || id_modalidade === 9) && total < 375.83) {
    total = 375.83;
  }

  return total;
};

const Resumo = ({position, current, checkAdvance, extraData, onSetBikeId, corPrimaria, uuid_segurado}) => {
  const history = useHistory();

  useImperativeHandle(ref, () => ({values: () => ({caller: CALLER, data: {coords: values.coords}})}));

  const {handleChange, values, errors, setFieldValue} = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema,
    initialErrors: strings.INITIAL_ERRORS,
  });

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          await api.post('segurado/sura_corretor/cadastra_coordenadas', {
            coords: {lat: position.coords.latitude, lng: position.coords.longitude},
            uuid: uuid_segurado,
          });
        } catch (error) {
          console.log(error);
        }

        setFieldValue('coords', {lat: position.coords.latitude, lng: position.coords.longitude});
      },
      () => {
        history.replace('/corretor/erro', {type: 'position'});
      },
    );
  }, []);

  useEffect(() => {
    if (!isMobile) window.open('/corretor/erro_smartphone');
  }, [history]);

  useEffect(() => {
    if (current === position) {
      extraData.segurado.segurado_bicicletas = extraData.segurado.segurado_bicicletas.map((bike) => {
        bike.total = somarTotal(bike.coberturas, bike.modalidade_bicicleta.id);

        return bike;
      });
    }
  });

  const DESCONTO =
    extraData.segurado.segurado_bicicletas?.length >= 2
      ? extraData.segurado.segurado_bicicletas?.length >= 2 && extraData.segurado.segurado_bicicletas?.length <= 3
        ? 15
        : 25
      : 0;

  const Resumo = useMemo(
    () => (
      <div className="mobileContent">
        <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}} className="resumoTitle">
          Dados do cliente
        </h1>

        <div className="groupOfInfos">
          <div className="infoItem spSize">
            <p>{extraData.segurado.nome}</p>
            <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Nome do cliente</span>
          </div>

          {extraData.segurado.nome_social && (
            <div className="infoItem spSize">
              <p>{extraData.segurado.nome_social}</p>
              <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Nome social</span>
            </div>
          )}

          <div className="infoItem">
            <p>{Mask.cpf.value(extraData.segurado.cpf)}</p>
            <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>CPF</span>
          </div>

          <div className="infoItem">
            <p>{extraData.segurado.email}</p>
            <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>E-mail</span>
          </div>
        </div>

        <div className="separator" />

        <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}} className="resumoTitle">
          Equipamentos
        </h1>

        {extraData.segurado.segurado_bicicletas.map((bike) => (
          <div key={bike.id}>
            <h4 align="center">{bike.modelo}</h4>

            <div className="groupOfInfos">
              <div className="infoItem">
                <p>{bike.numero_serie}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>N° de Serie</span>
              </div>

              <div className="infoItem">
                <p>{bike.modelo}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Modelo</span>
              </div>

              <div className="infoItem">
                <p>{bike.fabricante?.nome || bike.fabricante_modal}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Fabricante</span>
              </div>

              <div className="infoItem">
                <p>{bike.modalidade_bicicleta.tipo}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Modalidade</span>
              </div>

              <div className="infoItem">
                <p>{Mask.money.value(parseFloat(bike.valor_mercado).toFixed(2))}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Valor de novo</span>
              </div>

              <div className="infoItem">
                <p>{bike.categoria}</p>
                <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Categoria</span>
              </div>
            </div>

            <div className="labelPlans">
              <p style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Cobertura</p>
              <p style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Custo do seguro</p>
            </div>

            <div className="plansGroup">
              {bike.coberturas.map((c) => {
                const percentage = c.slider;
                const rcm = c.cobertura.label === 'resp_civil_materiais';
                let addValue;

                if (!!rcm && (Mask.money.raw(parseFloat(bike.valor_mercado).toFixed(2)) * +percentage) / 100 > 250000) {
                  addValue = 250000;
                } else {
                  addValue = percentage
                    ? (Mask.money.raw(
                        parseFloat(bike.valor_mercado * (bike.lmi_contratado ? bike.lmi_contratado / 100 : 1)).toFixed(2),
                      ) *
                        +percentage) /
                      100
                    : Mask.money.raw(
                        parseFloat(bike.valor_mercado * (bike.lmi_contratado ? bike.lmi_contratado / 100 : 1)).toFixed(2),
                      );
                }

                return (
                  <div key={c.id} className="planItem">
                    <div className="bodyPlanItem">
                      <p>{c.cobertura.nome}</p>
                    </div>

                    <div className="headerPlanItem" style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
                      {c.cobertura.label !== 'assistencia_ciclomotor' ? <p>LMI - {Mask.money.value(addValue)}</p> : <p></p>}
                      {extraData.segurado.cupom && extraData.segurado.cupom.tipo_desconto === 0 ? (
                        <p>
                          {Mask.money.value(
                            parseFloat(c.valor - (c.valor * extraData.segurado.cupom.valor_desconto) / 100).toFixed(2),
                          )}
                        </p>
                      ) : (
                        <p>{Mask.money.value(parseFloat(c.valor).toFixed(2))}</p>
                      )}
                    </div>
                  </div>
                );
              })}

              <div className="itemTotal mb-3">
                <p style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Prêmio do item</p>
                {extraData.segurado.cupom ? (
                  extraData.segurado.cupom.tipo_desconto === 0 ? (
                    <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                      {Mask.money.value(
                        parseFloat(
                          bike.total -
                            (bike.total * extraData.segurado.cupom.valor_desconto) / 100 -
                            ((bike.total - (bike.total * extraData.segurado.cupom.valor_desconto) / 100) * DESCONTO) / 100,
                        ).toFixed(2),
                      )}
                    </span>
                  ) : (
                    <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                      {Mask.money.value(
                        parseFloat(
                          bike.total -
                            extraData.segurado.cupom.valor_desconto -
                            ((bike.total - extraData.segurado.cupom.valor_desconto) * DESCONTO) / 100,
                        ).toFixed(2),
                      )}
                    </span>
                  )
                ) : (
                  <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                    {Mask.money.value(parseFloat(bike.total - (bike.total * DESCONTO) / 100).toFixed(2))}
                  </span>
                )}
              </div>

              {extraData.segurado.cupom && (
                <div className="groupOfInfos mb-3">
                  <div className="infoItem">
                    <p>{extraData.segurado.cupom.codigo}</p>
                    <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Cupom aplicado</span>
                  </div>

                  <div className="infoItem">
                    <p>
                      {extraData.segurado.cupom.tipo_desconto === 0
                        ? extraData.segurado.cupom.valor_desconto + '%'
                        : Mask.money.value(extraData.segurado.cupom.valor_desconto)}
                    </p>
                    <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Valor do cupom</span>
                  </div>
                </div>
              )}
            </div>

            <button
              type="button"
              tabIndex={-1}
              disabled={!!bike.fotos_enviadas}
              onClick={() => onSetBikeId(bike.id)}
              style={!!bike.fotos_enviadas ? {} : {background: !!corPrimaria ? corPrimaria : '#023a86'}}
              className={`btnAddEquipament ${!!bike.fotos_enviadas && 'bg-grey'}`}>
              <span>{!!bike.fotos_enviadas ? 'Fotos enviadas' : `Enviar fotos da ${bike.modelo}`}</span>
            </button>

            <div className="separator" />
          </div>
        ))}

        {/*   <button
          type="button"
          tabIndex={-1}
          onClick={() => window.octadesk.chat.toggle()}
          style={{background: !!corPrimaria ? corPrimaria : '#023a86', marginBottom: '1rem'}}
          className="btnAddEquipament">
          <span>Precisa de ajuda para prosseguir com a vistoria?</span>
        </button> */}

        {/* <h1 className="resumoTitle">Resumo do seguro</h1> */}

        {/* <div className="divTerms">
          <input type="checkbox" id="termos" tabIndex={-1} onChange={handleChange('termos')} />
          <label htmlFor="termos">
            Eu aceito os{' '}
            <a href="https://api.bikeinspec.com.br/uploads/termos_sura.pdf" target="blank">
              Termos de acordo
            </a>
          </label>
        </div> */}
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [extraData, handleChange, extraData.segurado.segurado_bicicletas],
  );

  return <div>{current === position && Resumo}</div>;
};

const validationSchema = Yup.object().shape({
  termos: Yup.bool().oneOf([true], 'Field must be checked!').required(strings.required),
});

export default React.memo(Resumo);
export const ref = React.createRef();
